
import 'slick-carousel';

const sliderPuppy = $('.rc_slider-puppy');
const buttons = $('.rc_buttons');
const firstButton = $('#rc_needs');
const secondButton = $('#rc_benefits');

$(document).ready(function(event, slick, currentSide) {
  currentSide === 1 ? secondButton.addClass('rc_btn-active') : firstButton.addClass('vbtn-active');
});

sliderPuppy.each(function() {
  $(this).slick({
    arrows: true,
    dots: false,
    draggable: false,
    speed: 500
  });
});

const highlightButton = (button, otherButton) => {
 button.addClass('rc_btn-active');
 otherButton.removeClass('rc_btn-active');
}

firstButton.click(function(event, slick, currentSide) {
  sliderPuppy.slick('slickGoTo', 0);
  highlightButton(firstButton, secondButton);
});

secondButton.click(function(event, slick, currentSide) {
  sliderPuppy.slick('slickGoTo', 1);
  highlightButton(secondButton, firstButton);
});

sliderPuppy.on('beforeChange', function(event, slick, currentSide) {
  if(currentSide === 1) {
    highlightButton(firstButton, secondButton);
  } else {
    highlightButton(secondButton, firstButton);
  }
});

const slider = $('.rc_slider');

slider.each(function () {
  $(this).slick({
    arrows: true,
    dots: true,
    draggable: false,
    speed: 500
  });
});

for(let i = 1; i <= 5; i++) {

  $(`.rc_dot-${i}`).on('mouseenter', function(event) {

    $(`.rc_dot-${i}-tip`).show();
  });

  $(`.rc_dot-${i}`).on('mouseleave', function(event) {

    $(`.rc_dot-${i}-tip`).hide();
  });
}



//////////////////
// WEBPACK FOOTER
// ./js/script.js
// module id = 3
// module chunks = 0